import { render, staticRenderFns } from "./AppNotifications.vue?vue&type=template&id=c4c83198"
import script from "./AppNotifications.vue?vue&type=script&lang=js"
export * from "./AppNotifications.vue?vue&type=script&lang=js"
import style0 from "./AppNotifications.vue?vue&type=style&index=0&id=c4c83198&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports